import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * 시험 제목 표시 + 인라인 수정.
 *
 * 목록과 응시 화면 양쪽에서 쓴다. 제목은 채점에 영향을 주지 않으므로
 * 응시 중에도 고칠 수 있다.
 *
 * 단어장에서도 같은 UI를 쓰므로 문구는 바꿔 끼울 수 있게 둔다.
 *
 * @param {string|null} title 현재 제목 (없으면 untitledKey 문구로 표시)
 * @param {(next: string) => Promise<boolean>} onSave 저장 성공 여부를 반환해야 한다
 */
const QuizTitleEditor = ({
  title,
  onSave,
  className = '',
  untitledKey = 'vocabulary.quiz.untitled',
  renameKey = 'vocabulary.quiz.renameQuiz',
  placeholderKey = 'vocabulary.quiz.quizNamePlaceholder',
}) => {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);

  const start = () => {
    setDraft(title || '');
    setEditing(true);
  };

  const commit = async () => {
    if (saving) return;
    const next = draft.trim();
    // 바뀐 게 없으면 굳이 서버를 부르지 않는다
    if (next === (title || '')) {
      setEditing(false);
      return;
    }
    setSaving(true);
    const ok = await onSave(next);
    setSaving(false);
    if (ok) setEditing(false);
  };

  if (!editing) {
    return (
      <span className={`quiz-title-view ${className}`}>
        <span className="quiz-title-text">{title || t(untitledKey)}</span>
        <button
          className="vocab-icon-btn"
          onClick={start}
          title={t(renameKey)}
          aria-label={t(renameKey)}
        >
          &#9998;
        </button>
      </span>
    );
  }

  return (
    <span className={`quiz-title-edit ${className}`}>
      <input
        type="text"
        maxLength={100}
        value={draft}
        autoFocus
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') commit();
          if (e.key === 'Escape') setEditing(false);
        }}
        placeholder={t(placeholderKey)}
      />
      <button className="vocab-btn vocab-btn-primary" onClick={commit} disabled={saving}>
        {saving ? t('vocabulary.loading') : t('save')}
      </button>
      <button className="vocab-btn" onClick={() => setEditing(false)} disabled={saving}>
        {t('cancel')}
      </button>
    </span>
  );
};

export default QuizTitleEditor;
